import { getMainJs } from './core/utils';

const script = getMainJs();

export default {
  shopify: typeof window.Shopify !== 'undefined',
  // detect in the frontend if we should use shopify selling plans or not
  shopify_selling_plans: typeof script?.dataset.shopifySellingPlans !== 'undefined'
};
